import { hc } from "hono/client";
import type { InferResponseType, InferRequestType } from "hono/client";
import type { AppType } from "cms/lambda/app";

export type { AppType };
export type { InferResponseType, InferRequestType };

export function createCmsClient(baseUrl: string) {
  return hc<AppType>(baseUrl);
}

export type CmsApiClient = ReturnType<typeof createCmsClient>;
